import { RouteObject } from '@rocketlane/rocket-router';
import { SecureRoute } from 'routes/route-with-permission-check';
import { ROUTE_PATHS } from 'routes/routes-paths';
import { AllTasksPage, AllTasksBoard } from 'routes/vendor/lazy-imports';
// import { retryImportInsideRoutesDefinition } from 'utils/lazyWithRetry';

export const allTasksRoute: RouteObject = {
  path: ROUTE_PATHS.ALL_TASKS,
  element: (
    <SecureRoute>
      <AllTasksPage />
    </SecureRoute>
  ),
  // async lazy() {
  //   const { AllTasksV2Page } = await retryImportInsideRoutesDefinition(
  //     () => import('./all-tasks-v2-page'),
  //   );

  //   return {
  //     element: <AllTasksV2Page />,
  //   };
  // },
};

export const allTaskBoardsPageRoute: RouteObject = {
  path: `${ROUTE_PATHS.ALL_TASKS}/${ROUTE_PATHS.PROJECT_TASKS_BOARD}`,
  element: (
    <SecureRoute>
      <AllTasksBoard />
    </SecureRoute>
  ),
  // async lazy() {
  //   const { AllTasksBoardPage } = await retryImportInsideRoutesDefinition(
  //     () => import('./board'),
  //   );

  //   return {
  //     element: (
  //       <SecureRoute>
  //         <AllTasksBoardPage />
  //       </SecureRoute>
  //     ),
  //   };
  // },
};
